/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useOrgSettings } from "hooks/use-org-settings";

const useFeatureFlag = (feature) => {
    const { getOrgSettingsBoolean } = useOrgSettings(feature);
    const flag = getOrgSettingsBoolean(feature);
    return flag;
};

export { useFeatureFlag };
